import { Field, TextInput, tokens } from '@hotjar/hotsauce';
import * as React from 'react';
import styled from '@emotion/styled';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { useForm } from 'react-hook-form';

const TRANSLATION_DOMAIN = 'account:new-organization';
const inputLabel = 'add-organization-input';

const S = {
  Field: styled(Field)`
    margin-bottom: ${tokens.spacer.x3};
  `,
};

interface FormInputs {
  organizationName: string;
}

export const AddOrganizationForm = (props: {
  addOrganization(organizationName: string): void;
}): JSX.Element => {
  const { addOrganization } = props;
  const { t } = useTranslationWithPrefix(TRANSLATION_DOMAIN);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>();

  return (
    <form
      id="create-org-form"
      onSubmit={handleSubmit((data) => {
        addOrganization(data.organizationName);
      })}
    >
      <S.Field
        labelText={t('input-label')}
        inputId={inputLabel}
        isRequired
        isInvalid
        invalidText={errors.organizationName?.message}
      >
        <TextInput
          id={inputLabel}
          name="organizationName"
          ref={register({ required: t('required-error') as string })}
          placeholder={t('input-placeholder')}
          isInvalid={!!errors.organizationName}
        />
      </S.Field>
    </form>
  );
};
